import type { Filter } from '@coursera-web/cds-labs';

import type { ComplexCollectionFilter } from 'bundles/browse-common/types/complexCollections';

export function toCollectionsModuleFilter(filter: ComplexCollectionFilter): Filter {
  return {
    id: filter.context.id,
    filterName: filter.label,
  };
}
